export default "__VITE_ASSET__zfgkcRJj__"